export default __webpack_public_path__ + "static/PAPC-736-3cc5175080c04dd221b1bd921d2f7b53.jpg";